export default "__VITE_ASSET__5dc7d87b__"